import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PokPortalComponent } from './pok-portal.component';

const routes: Routes = [
  {
    path: 'pok-portal',
    component: PokPortalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PokPortalRoutingModule {}
